import { serializeHttpParams } from './serializeHttpParams'

export function appendSearchParams(url: URL, object: Object): void {
  const params = serializeHttpParams(object)
  Object.keys(params).forEach(param => {
    if (params[param] !== undefined) {
      url.searchParams.append(param, params[param])
    }
  })
}
